import React from 'react';
import cx from 'classnames';

import styles from './Tip.module.scss';
import usePresenter from './Tip.presenter';
import { TipCombinedProps } from './types';

const Tip: React.FC<TipCombinedProps> = (props) => {
  const { className } = usePresenter(props);
  const currentStyle = styles.tip;

  return (
    <div className={cx(currentStyle, className)}>
    </div>
  );
};

export default Tip;
